import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';
import { NekoSpinner } from '../misc/Spinner';

import { Icon } from '@iconify/react';
import checkboxBlankOutline from '@iconify/icons-mdi/checkbox-blank-outline';
import checkboxMarked from '@iconify/icons-mdi/checkbox-marked';

/**
 * @param {string} id
 * @param {string} name
 * @param   {bool} checked
 * @param {string} label
 * @param {string} description
 */
const StyledNekoCheckbox = Styled(props => {
  const { id, name, checked = false, onChange, label, description, isPro, disabled, requirePro = false, isBusy = false } = props;

  const showUpProOnly = requirePro && !isPro;
  const isDisabled = disabled || showUpProOnly;
  const disabledClass = isDisabled ? 'disabled' : '';

  const onClick = () => {
    if (isDisabled) {
      return;
    }
    if (!onChange) {
      console.log(`The onChange handler it not set for the NekoCheckbox.`, props);
      return;
    }
    onChange(!checked, id);
  };

  return (
    <div className={['nui-checkbox', props.className, disabledClass].join(' ')}
      onClick={(e) => e.stopPropagation() }>
      <input id={id} name={name} type="checkbox" defaultChecked={false} disabled={isDisabled || isBusy} />
      <label htmlFor={id} onClick={onClick}>
        <div className="nui-checkbox-check-container">
          {isBusy
            ? <div className='nui-checkbox-busy-container'><Icon icon={checkboxBlankOutline} width="30px" height="30px" 
            color={Theme.blue} /><NekoSpinner type="circle" size="16px" style={{ position: 'absolute', top: '7px', left: '7px' }} /></div>
            : <Icon icon={checked ? checkboxMarked : checkboxBlankOutline} width="30px" height="30px" 
            color={isDisabled ? Theme.disabledForm : Theme.blue} />
          }
        </div>
        <div className="nui-checkbox-inner-container">
          <span className="label">{label}<ProOnly className="inline" show={showUpProOnly} /></span>
          {description ? <small className="description">{description}</small> : null}
        </div>
      </label>
    </div>
  );
})`
  font-family: ${Theme.fontFamily};
  user-select: none;

  &.disabled {
    color: ${Theme.disabledForm};

    label {
      cursor: default;
    }
  }

  input {
    display: none;
  }

  label {
    cursor: pointer;
    display: flex;
  }
  .nui-checkbox-check-container {
    display: flex;
    align-content: center;
    flex-basis: 30px;

    .nui-checkbox-busy-container {
      position: relative
    }
  }
  .nui-checkbox-inner-container {
    margin-left: 4px;

    .label {
      display: block;
      font-size: 14px;
      line-height: 28px;
    }
    
    .description {
      display: block;
      font-size: ${Theme.fontSizeSmall};
      line-height: 14px;
      color: ${Theme.darkGray};

      * {
        font-size: ${Theme.fontSizeSmall};
        line-height: inherit;
        margin: 0;
      }
    }
  }
`;

const NekoCheckbox = (props) => {
  return (<StyledNekoCheckbox {...props} />);
};

NekoCheckbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  isPro: PropTypes.bool,
  requirePro: PropTypes.bool,
  isBusy: PropTypes.bool,
};

NekoCheckbox.defaultProps = {
  id: undefined,
  name: undefined,
  checked: false,
  label: undefined,
  description: undefined,
  isPro: false,
  requirePro: false,
  isBusy: false,
};

export { NekoCheckbox };
